import { connect } from 'react-redux'
import Feed from './components/Feed'
import { launcherOpenUrl } from './imports'
import { getLocalizedNews } from './selectors'

function mapStateToProps(state) {
    const localizedNews = getLocalizedNews(state)
    return {
        fetching: localizedNews.fetching,
        outdated: localizedNews.outdated,
        news: localizedNews.news,
        onNewsClick: launcherOpenUrl,
    }
}

export default connect(mapStateToProps)(Feed)



// WEBPACK FOOTER //
// ./src/features/News/connected.js